import {DatePicker, Form} from 'antd';

export function Since() {
    return (
        <Form.Item
            label={'Since'}
            name={'startDate'}
            rules={[{required: true, message: 'Please input the date'}]}
        >
            <DatePicker id={'startDate'} inputReadOnly allowClear={false}/>
        </Form.Item>
    )
}
